var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.hasRouter
        ? _c(
            "split-pane",
            [
              _c("routes-tree", { attrs: { slot: "left" }, slot: "left" }),
              _c("routes-meta", { attrs: { slot: "right" }, slot: "right" })
            ],
            1
          )
        : _c("div", { staticClass: "notice" }, [
            _c("div", [_vm._v("\n      No routes detected.\n    ")])
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }